/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import BeneficiaryAccountGridView from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountGridView/index.jsx";
import BeneficiaryAccountListView from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountListView/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import {
  addBeneficiaryAccountLabel,
  getAllBeneficiaryAccounts,
  removeBeneficiaryAccountLabel,
  resetBeneficiaryToggle,
  setBeneficiaryToggle,
} from "../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import useMultiSelect from "../../../../utils/useMultiSelect.js";
import "./index.css";

const BeneficiaryAccountViewAll = ({
  id,
  type,
  typepop,
  handleButtonClick,
  associateAccount,
  associatepanNumber,
  associateIFSC,
  associateaccountNumber,
  setOpenBeneAssociate,
  beneAccountId,
  flow,
  txnPayLoad,
  BeneTxnAssocAcct,
  associateTxn,
  subType,
  remPan,
  remAccount,
  remIFSC,
  onCardNavigate,
  accActiveInactiveState,
  activeInactivePan,
  activeInactiveFlow,
  activeInactiveIfsc,
  activeInactiveBank,
  setIsalertPopup,
  setFlowSelectedId,
  classifiedFlow = false,
  panNum,
  ifscCode,
  bankAccNumber,
  activeType,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const filterRef = useRef(null);
  const lastElementRef = useRef();
  const scrollContainerRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  const isPopupMode =
    typepop === "popup" ||
    type === "activeInactive" ||
    type === "confirm_create_account";

  const defaults =
    location?.state?.approvalStatus &&
    location?.state?.approvalStatus !== "all" &&
    !isPopupMode
      ? {
          status: location.state.approvalStatus,
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        }
      : {
          pageno: GlobalConfiguration.lengthCheckOne,
          pagesize: dropdownOptions[0],
        };

  const {
    searchParam: urlSearchParam,
    handleSearchParams: urlHandleSearchParams,
    handleClearSearchParam: urlHandleClearSearchParam,
  } = useCustomSearchParams(defaults);

  const searchParam = isPopupMode
    ? new URLSearchParams(defaults)
    : urlSearchParam;

  const handleSearchParams = isPopupMode ? () => {} : urlHandleSearchParams;

  const handleClearSearchParam = isPopupMode
    ? () => {}
    : urlHandleClearSearchParam;

  const convertDate = (dateString) => {
    if (!dateString) return;
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const updatedStatus = location.state ? location.state.approvalStatus : "";
  const approvalStatus = typepop === "popup" ? "" : updatedStatus;

  const [active, setActive] = useState("");
  const [labels, setLabels] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [endDate, setEndDate] = useState(null);
  const [mainData, setMainData] = useState([]);
  const [Labeldata, setLabeldata] = useState([]);
  const [inputData, setInputData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [currentStatus, setCurrentStatus] = useState(
    searchParam.get("status") || approvalStatus || "",
  );
  const [loadingData, setLoadingData] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [searchPanText, setSearchPanText] = useState(
    associateAccount || associateTxn || BeneTxnAssocAcct
      ? associatepanNumber
      : "",
  );
  const [accountNumber, setAccountNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveBank
      : type === "confirm_create_account"
        ? bankAccNumber
        : searchParam.get("accno") || "",
  );
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [searchIfscText, setSearchIfscText] = useState("");
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",") || [],
  );
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [searchAccountText, setSearchAccountText] = useState("");
  const [isWheelScrolling, setIsWheelScrolling] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [isIfsc, setIsIfsc] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveIfsc
      : type === "confirm_create_account"
        ? ifscCode
        : searchParam.get("ifsc") || "",
  );
  const [panNumber, setPanNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Pan" || activeInactiveFlow === "Existing")
      ? activeInactivePan
      : type === "confirm_create_account"
        ? panNum
        : searchParam.get("pan") || "",
  );
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCategory") || "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const filteredData = accumulatedData;
  const selectableAccounts = accumulatedData?.map((item) => ({
    ...item,
    id: item?.id,
  }));

  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { services } = useSelector((state) => state.refreshToken);
  const { toggle } = useSelector((state) => state.beneficiaryAccount);

  const status =
    flow === "unassignCategory"
      ? ["approved", "pending", "rejected"]
      : [
          services?.includes("BAAccount") || services?.includes("Admin")
            ? "require approval"
            : "pending",
          "approved",
          "rejected",
          "blocked",
          "archived",
        ];

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const fetchSearchData = async () => {
    let response;
    let data = [];
    setLoadingData(true);

    switch (active) {
      case "Categories":
        response = await dispatch(
          getAllCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.id,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            return itm.includes(searchUserTextDebounce);
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  async function fetchData() {
    setLoading(true);
    try {
      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        ...(subType ? { reimbursement_account: "Y" } : {}),
        ...(type === "activeInactive" && {
          associate:
            type === "activeInactive" && accActiveInactiveState === "active"
              ? ["pending", "approved"]
              : type === "activeInactive" &&
                  accActiveInactiveState === "inactive"
                ? ["blocked", "archived", "rejected"]
                : undefined,
        }),
      };

      const addParamsBasedOnSelection = () => {
        if (currentStatus !== "all") {
          queryParams.approval_status =
            currentStatus === "require approval" ? "pending" : currentStatus;
        }
        if (currentCategory !== "") {
          queryParams.category_ids = Array.isArray(currentCategory)
            ? currentCategory
            : [currentCategory];
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          startDateFilter !== GlobalConfiguration?.lengthCheckZero &&
          endDateFilter !== GlobalConfiguration?.lengthCheckZero &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date =
            startDateFilter + GlobalConfiguration.day_in_seconds;
          queryParams.end_date =
            endDateFilter + GlobalConfiguration.day_in_seconds;
        }

        if (accountNumber !== "" || remAccount) {
          queryParams.bank_account_no = remAccount ? remAccount : accountNumber;
        }

        if (isIfsc !== "" || remIFSC) {
          queryParams.ifsc = remIFSC
            ? remIFSC.toUpperCase()
            : isIfsc.toUpperCase();
        }

        if (panNumber !== "" || remPan) {
          queryParams.pan = remPan
            ? remPan.toUpperCase()
            : panNumber.toUpperCase();
        }

        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (LabelSearchText?.length !== GlobalConfiguration?.lengthCheckZero) {
          queryParams.labels = LabelSearchText;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(getAllBeneficiaryAccounts(queryParams));
      const newData = response?.payload?.beneficiary_accounts || [];
      setMainData(response?.payload);
      setAccumulatedData(newData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleDateChange = (dates) => {
    if (!dates) {
      setStartDate(null);
      setEndDate(null);
      setStartDateFilter("");
      setEndDateFilter("");
      return;
    }

    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      const startTimestamp = Math.floor(start.getTime() / 1000);
      const endTimestamp = Math.floor(end.getTime() / 1000);
      setStartDateFilter(startTimestamp);
      setEndDateFilter(endTimestamp);
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };
  const handleClearFilters = () => {
    setCurrentCategory("");
    setStartDate(null);
    setEndDate(null);
    setStartDateFilter("");
    setEndDateFilter("");
    setAccountNumber("");
    setSearchAccountText("");
    setShowSearchBar(false);
    setSearchIfscText("");
    setSearchUserText("");
    setIsIfsc("");
    setLabelSearchText([]);
    setisLabelClicked(false);
    setCurrentStatus("");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSearchUserTextDebounce("");
    if (
      (associateAccount ||
        BeneTxnAssocAcct ||
        associateTxn === "associateTxn") &&
      activeType === "pan"
    ) {
      setSearchPanText(searchPanText);
      setPanNumber("");
    } else if (activeType === "bank") {
      setAccountNumber(accountNumber);
      setSearchAccountText(searchAccountText);
      setSearchIfscText(searchIfscText);
      setPanNumber("");
      setSearchPanText("");
    } else {
      setSearchPanText("");
      setPanNumber("");
    }
    if (type === "activeInactive" && activeInactiveFlow === "Pan") {
      setPanNumber(activeInactivePan);
    } else if (type === "activeInactive" && activeInactiveFlow === "Bank") {
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    } else if (activeInactiveFlow === "Existing") {
      setPanNumber(activeInactivePan);
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    } else if (type === "confirm_create_account") {
      if (activeType === "pan") {
        setPanNumber(panNum);
      } else {
        setAccountNumber(bankAccNumber);
        setIsIfsc(ifscCode);
      }
    }
  };

  const handleSubmit = (key, value) => {
    if (
      typepop !== "popup" &&
      type !== "activeInactive" &&
      type !== "confirm_create_account"
    ) {
      handleSearchParams(key, value);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(LabelAccounts)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);
    const res = await dispatch(
      addBeneficiaryAccountLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (addBeneficiaryAccountLabel?.fulfilled?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addBeneficiaryAccountLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (addBeneficiaryAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(LabelAccounts)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);
    const res = await dispatch(
      removeBeneficiaryAccountLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (removeBeneficiaryAccountLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeBeneficiaryAccountLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (removeBeneficiaryAccountLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      if (!showSearchBar) {
        dispatch(setBeneficiaryToggle(newToggleValue));
      }
    }
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    if (
      isLabelClicked &&
      value === PaginationConfiguration.paginationSmall &&
      LabelAccounts?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(LabelAccounts, setLabelAccounts, value, LabelAccounts);
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    toggleDropdown();
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
      setIsWheelScrolling(false);
    }
  }, []);

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const handleWheel = useCallback((event) => {
    setIsWheelScrolling(true);
  }, []);

  const totalRecordCount = Number(mainData?.total_count || 0);

  const effectiveSelectCap =
    totalRecordCount > 0 && totalRecordCount <= Number(selectedValue)
      ? totalRecordCount
      : Number(selectedValue);

  const isAllSelected =
    LabelAccounts?.length === effectiveSelectCap && effectiveSelectCap > 0;

  const handleSelectAll = () => {
    handleMultiSelectAll(
      LabelAccounts,
      setLabelAccounts,
      selectedValue,
      selectableAccounts,
    );
  };

  const handleLabelAccountSelect = (account) => {
    handleSingleSelect(LabelAccounts, setLabelAccounts, selectedValue, {
      ...account,
      id: account?.id,
    });
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      fetchData();
      setLabelAccounts([]);
      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setCurrentPage(GlobalConfiguration.lengthCheckOne);
    }
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        (currentStatus !== "all" && !!currentStatus) ||
        LabelSearchText?.length !== GlobalConfiguration?.lengthCheckZero,
    );
  };

  useEffect(() => {
    if (active?.length) {
      fetchSearchData();
    }
  }, [active]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(setBeneficiaryToggle(false));
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [handleKeyDown, handleWheel]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("beneficiaryAccountLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    currentPage,
    currentStatus,
    currentCategory,
    searchUserText,
    startDateFilter,
    endDateFilter,
    accountNumber,
    pageSize,
    panNumber,
    isIfsc,
    associateIFSC,
    associateaccountNumber,
    associatepanNumber,
    LabelSearchText,
    remAccount,
    remIFSC,
    remPan,
    accActiveInactiveState,
    markerData,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    isIfsc,
    currentStatus,
    LabelSearchText,
  ]);

  useEffect(() => {
    if (startDateFilter && endDateFilter && !startDate && !endDate) {
      const start = new Date(
        startDateFilter * IntervalConfiguration.intervalMedium,
      );
      const end = new Date(
        endDateFilter * IntervalConfiguration.intervalMedium,
      );
      setStartDate(start);
      setEndDate(end);
    }
  }, [startDateFilter, endDateFilter]);

  useEffect(() => {
    if (
      typepop === "popup" ||
      type === "activeInactive" ||
      type === "confirm_create_account"
    ) {
      dispatch(resetBeneficiaryToggle());
    }
  }, []);

  useEffect(() => {
    if (filterRef.current) {
      filterRef.current.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
      });
    }
  }, [toggle, currentPage, accumulatedData]);

  useEffect(() => {
    if (type === "confirm_create_account") {
      setPanNumber(panNum || "");
      setIsIfsc(ifscCode || "");
      setAccountNumber(bankAccNumber || "");
    }
  }, [panNum, ifscCode, bankAccNumber, type]);

  return (
    <>
      <div
        className={`bg-primary-bg flex flex-col relative overflow-hidden ${typepop === "popup" || type === "activeInactive" || type === "confirm_create_account" ? "flex-1 overflow-hidden h-height-full" : "h-full-height"} `}
        style={{
          width:
            typepop === "popup" ||
            type === "activeInactive" ||
            type === "confirm_create_account"
              ? ""
              : "var(--full-width)",
        }}
      >
        {showInnerSearchBar && (
          <div className="absolute top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-light-opacity z-z-index-header"></div>
        )}

        <div
          className={`absolute bg-primary-nav ${showInnerSearchBar ? "z-z-index-content pointer-events-none" : "z-z-index-dropdown"} shadow-box-shadow-top ${
            typepop === "popup" ||
            type === "activeInactive" ||
            type === "confirm_create_account"
              ? "w-full Qmd:w-full-popup-width rounded-none bottom-bottom-base"
              : "bottom-bottom-base w-full rounded-none"
          } ${showInnerSearchBar && "pointer-events-none"}`}
        >
          {accumulatedData?.length > GlobalConfiguration?.lengthCheckZero &&
            filteredData?.length > GlobalConfiguration?.lengthCheckZero &&
            !loading && (
              <>
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  setIsOpen={setIsOpen}
                  typePopup={
                    typepop === "popup" ||
                    type === "activeInactive" ||
                    type === "confirm_create_account"
                  }
                />
              </>
            )}
        </div>

        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={LabelAccounts}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
            />
          </div>
        )}

        <div
          className={`relative z-z-index-overlay bg-primary-nav ${showInnerSearchBar && " fixed  w-full "}`}
        >
          <div className=" ">
            <div
              className={`  ${typepop === "popup" || type === "activeInactive" || type === "confirm_create_account" ? " hidden Qsmd:block" : " hidden Qmd:block h-navbar-breadcrumb-height"}   w-full `}
            ></div>
          </div>
        </div>

        <div
          className={`flex flex-col items-center justify-center z-z-index-overlay Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act relative ${typepop === "popup" || type === "activeInactive" || type === "confirm_create_account" ? " w-full Qmd:w-full-popup-width" : "w-full-width"}`}
        >
          <TopNavComponent
            loading={loading}
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={
              isLabelClicked
                ? {
                    btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      const textContent = e.target.textContent.trim();
                      if (textContent === "Clear") {
                        setLabelAccounts([]);
                      }
                      if (textContent === "Cancel") {
                        setisLabelClicked(false);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: showSearchBar,
                    hoverOption: "white",
                  }
                : undefined
            }
            topNavCtaBtn2Needed={false}
            topNavCtaBtn2Props={
              isLabelClicked
                ? {
                    btnText: "Assign labels",
                    btnType: "button",
                    enabledBgColor: LabelAccounts?.length
                      ? "var(--text-primary)"
                      : "var(--text-disabled)",
                    handleFunction: (e) => {
                      if (loading) return;
                      e.stopPropagation();
                      if (LabelAccounts?.length) {
                        setIsLabelPopupOpen(true);
                      }
                    },
                    inActiveVariantNeeded: true,
                    enabledTextColor: LabelAccounts?.length
                      ? "var(--primary-bg)"
                      : "Var(--text-primary)",
                    isDisabled: showSearchBar || !LabelAccounts?.length,
                    hoverOption: LabelAccounts?.length ? "black" : "white",
                  }
                : undefined
            }
            BottomSubText={
              isLabelClicked
                ? "Select accounts to apply labels. These will be used to generate statistics for the associated accounts."
                : undefined
            }
            BottomSubTextVaraint="primary"
            isSelectionView={isLabelClicked && true}
            isToggleNeeded={true}
            toggleProps={
              !isLabelClicked
                ? {
                    state: toggle,
                    title: toggle ? "Grid View" : "List View",
                    isDisabled: showSearchBar,
                    handleClick: () => handleToggle(!toggle),
                  }
                : undefined
            }
            selectionText={`Account selected - ${LabelAccounts?.length || "0"}`}
            selectionBtnProps={
              isLabelClicked
                ? {
                    btnText: `Select up to ${Number(selectedValue)}`,
                    btnType: "button",
                    enabledBgColor: isAllSelected
                      ? "var(--positive-bg)"
                      : "var(--primary-nav-act)",
                    handleFunction: () => {
                      handleSelectAll();
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled:
                      loading ||
                      selectableAccounts?.length ===
                        GlobalConfiguration.lengthCheckZero,
                    hoverOption:
                      LabelAccounts?.length === Number(selectedValue)
                        ? "black"
                        : "white",
                    icon: isAllSelected
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                  }
                : undefined
            }
            assignLabelNeeded={true}
            assignTagNeeded={true}
            assignLabelProps={
              !isLabelClicked
                ? {
                    handleFunction: () => {
                      if (!accumulatedData?.length) return;
                      if (
                        type === "activeInactive" ||
                        type === "confirm_create_account" ||
                        typepop === "popup" ||
                        flow === "beneTxn"
                      ) {
                        actionRestricted();
                      } else if (
                        services?.includes("ALabel") &&
                        services?.includes("RLabel")
                      ) {
                        if (showSearchBar) {
                          return;
                        }
                        setisLabelClicked((prev) => {
                          if (prev) {
                            setLabelAccounts([]);
                          }
                          return !prev;
                        });
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ALabel,RLabel",
                          },
                        });
                      }
                    },
                    isDisabled:
                      !accumulatedData?.length ||
                      type === "activeInactive" ||
                      type === "confirm_create_account" ||
                      typepop === "popup" ||
                      showSearchBar ||
                      flow === "beneTxn",
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,

                    hoverOption: "white",
                    buttonRef: null,
                    title:
                      "Labels will be used to generate statistics for the associated accounts",
                  }
                : undefined
            }
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: (val) => handleSearch(val),
              searchText: searchUserTextDebounce,
              searchPlaceholder: subType
                ? "Search reimbursement account"
                : "Search beneficiary account",
              filterPlaceholder:
                "Name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("search", val);
                    setSearchUserText(val);
                  },
                  isDropdown: false,
                  isDisabled: loading,
                },
                {
                  name: "Account number",
                  short_name: subType ? "Reimb A/c" : "Bene A/c",
                  isMulti: false,
                  value:
                    type === "confirm_create_account" && bankAccNumber
                      ? bankAccNumber
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Bank" ||
                            activeInactiveFlow === "Existing")
                        ? activeInactiveBank
                        : remAccount !== "" && typepop === "popup"
                          ? remAccount
                          : accountNumber,
                  setValue: (val) => {
                    handleSubmit("accno", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setAccountNumber(val);
                  },
                  isDropdown: false,
                  valueType: "string",
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : (remAccount !== "" && typepop === "popup") ||
                          (type === "confirm_create_account" &&
                            ifscCode &&
                            bankAccNumber)
                        ? true
                        : false,
                },
                {
                  name: "IFSC",
                  short_name: "IFSC",
                  isMulti: false,
                  value:
                    type === "confirm_create_account" && ifscCode
                      ? ifscCode
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Bank" ||
                            activeInactiveFlow === "Existing")
                        ? activeInactiveIfsc
                        : remIFSC !== "" && typepop === "popup"
                          ? remIFSC
                          : isIfsc.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("ifsc", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setIsIfsc(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : (remIFSC !== "" && typepop === "popup") ||
                          (type === "confirm_create_account" &&
                            ifscCode &&
                            bankAccNumber)
                        ? true
                        : false,
                },
                {
                  name: "PAN",
                  short_name: "PAN",
                  isMulti: false,
                  value:
                    type === "confirm_create_account" && panNum
                      ? panNum
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing")
                        ? activeInactivePan
                        : remPan !== "" && typepop === "popup"
                          ? remPan
                          : panNumber.toUpperCase(),
                  setValue: (val) => {
                    handleSubmit("pan", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setPanNumber(val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Pan" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : (remPan !== "" && typepop === "popup") ||
                          (type === "confirm_create_account" && panNum)
                        ? true
                        : false,
                },
                {
                  name: "Categories",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  displayValue: displayCategory,
                  setValue: (val) => {
                    const c =
                      categories.filter((x) => x.id === val)[0]?.name ?? "";
                    setDisplayCategory(c);
                    handleSubmit("category", val);
                    handleSubmit("dispCategory", c);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentCategory(val);
                  },
                  isDropdown: true,
                  isDisabled: loading,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    handleSubmit("label", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setLabelSearchText(val);
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: loading,
                },
              ],
              filters: [
                {
                  name: "Account status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  value: currentStatus,
                  dropdownPlaceHolder: "Select status",
                  isDisabled: type === "activeInactive",
                  options: status,
                  statusPop: true,
                  handleChange: (val) => {
                    handleSubmit("status", val);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    setCurrentStatus(val);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value:
                    (startDate && endDate) ||
                    (startDateFilter && endDateFilter),
                  isDisable: false,
                  startDate:
                    startDate ||
                    (startDateFilter
                      ? new Date(
                          startDateFilter *
                            IntervalConfiguration.intervalMedium,
                        )
                      : null),
                  endDate:
                    endDate ||
                    (endDateFilter
                      ? new Date(
                          endDateFilter * IntervalConfiguration.intervalMedium,
                        )
                      : null),
                  handleChange: (date) => {
                    handleSubmit("date", date);
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleDateChange(date);
                  },
                },
              ],
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                currentStatus !== "" ||
                loading
              ),
              isSearchClearAllDisabled:
                (type === "confirm_create_account" ||
                  type === "activeInactive") &&
                ((isIfsc?.length &&
                  accountNumber.length &&
                  !panNumber.length &&
                  !currentCategory?.length &&
                  !displayCategory?.length &&
                  !LabelSearchText?.length &&
                  !searchUserText?.length) ||
                  (!isIfsc?.length &&
                    !accountNumber?.length &&
                    panNumber?.length &&
                    !currentCategory?.length &&
                    !displayCategory?.length &&
                    !LabelSearchText?.length &&
                    !searchUserText?.length) ||
                  (type === "activeInactive" &&
                    activeInactiveFlow === "Existing" &&
                    isIfsc?.length &&
                    accountNumber?.length &&
                    panNumber?.length &&
                    !currentCategory?.length &&
                    !displayCategory?.length &&
                    !LabelSearchText?.length &&
                    !searchUserText?.length &&
                    !(startDateFilter && endDateFilter)))
                  ? true
                  : !(
                      accountNumber?.length ||
                      isIfsc?.length ||
                      panNumber?.length ||
                      displayCategory?.length ||
                      currentCategory?.length ||
                      LabelSearchText?.length ||
                      searchUserText?.length ||
                      loading
                    ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loading: loadingData,
              setLoading: setLoadingData,
              isShowSortBy: false,
              isShowFilter: true,
              loadingData: loadingData,
              isSortDisabled: loading,
              isFilterDisabled: loading,
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
          />
        </div>
        {showInnerSearchBar && (
          <div className="absolute bg-PopUp-BackDrop bg-opacity-light-opacity pointer-events-none w-full h-full z-z-index-header"></div>
        )}
        {!toggle ? (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            id={
              typepop === "popup" ||
              type === "activeInactive" ||
              type === "confirm_create_account"
                ? ""
                : "infinityScrollContainerBeneView"
            }
            className={` ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            } ${
              typepop === "popup" ||
              type === "activeInactive" ||
              type === "confirm_create_account"
                ? "h-full flex flex-col flex-1 overflow-hidden min-h-0"
                : "!flex !flex-col overflow-auto h-height-full flex-1 min-h-0"
            }`}
            style={{
              overflow: !isWheelScrolling && "hidden",
              marginBottom: !isWheelScrolling && "var(--margin-base)",
            }}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();

                return false;
              }
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center w-full h-full flex-1">
                <Loader />
              </div>
            ) : filteredData?.length > GlobalConfiguration.lengthCheckZero ? (
              <div
                style={{
                  scrollPaddingTop: "var(--padding-md)",
                  scrollPaddingBottom: "var(--padding-md)",
                }}
                className={`w-full scroll flex flex-col min-h-0 items-center h-full-height overflow-y-auto ${showInnerSearchBar && "pointer-events-none"}`}
                ref={filterRef}
              >
                <BeneficiaryAccountGridView
                  filterRef={filterRef}
                  subType={subType}
                  id={id}
                  data={filteredData}
                  typepop={typepop}
                  type={type}
                  handleButtonClick={handleButtonClick}
                  associateAccount={associateAccount}
                  setOpenBeneAssociate={setOpenBeneAssociate}
                  showSearchBar={showSearchBar}
                  beneAccountId={beneAccountId}
                  txnPayLoad={txnPayLoad}
                  associateTxn={associateTxn}
                  isLabelClicked={isLabelClicked}
                  handleLabelSelect={handleLabelAccountSelect}
                  LabelAccounts={LabelAccounts}
                  setlableInput={(e) => {}}
                  Labeldata={Labeldata}
                  setLabeldata={setLabeldata}
                  onCardNavigate={onCardNavigate}
                  setIsalertPopup={setIsalertPopup}
                  setFlowSelectedId={setFlowSelectedId}
                  classifiedFlow={classifiedFlow}
                />
              </div>
            ) : accumulatedData?.length ===
                GlobalConfiguration?.lengthCheckZero &&
              filteredData?.length === GlobalConfiguration?.lengthCheckZero &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full"
                style={{
                  height:
                    (typepop === "popup" ||
                      type === "activeInactive" ||
                      type === "confirm_create_account") &&
                    showSearchBar
                      ? " var(--width-full)"
                      : "",
                  overflowY: showSearchBar && "scroll",
                }}
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
                />
                <p
                  className={`text-font-sm text-text-primary items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  No data found.
                </p>
                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <></>
                    // <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                    //   {accActiveInactiveState === "active"
                    //     ? "There are no existing active accounts linked to the provided bank under the beneficiary account classification."
                    //     : "There are no existing inactive accounts linked to the provided bank under the beneficiary account classification."}
                    // </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <></>
                    // <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                    //   {accActiveInactiveState === "active"
                    //     ? "There are no existing active accounts linked to the provided PAN under the beneficiary account classification."
                    //     : "There are no existing inactive accounts linked to the provided PAN under the beneficiary account classification."}
                    // </p>
                  )
                ) : (
                  (type === "confirm_create_account"
                    ? currentCategory !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied ||
                      (activeType === "Pan"
                        ? accountNumber !== "" || isIfsc !== ""
                        : panNumber !== "")
                    : currentCategory !== "" ||
                      panNumber !== "" ||
                      accountNumber !== "" ||
                      isIfsc !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        ) : (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            id={
              typepop === "popup" ||
              type === "activeInactive" ||
              type === "confirm_create_account"
                ? ""
                : "infinityScrollContainerBeneView"
            }
            className={` ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            } ${
              typepop === "popup" ||
              type === "activeInactive" ||
              type === "confirm_create_account"
                ? "h-full flex flex-col flex-1 overflow-hidden min-h-0"
                : "!flex !flex-col overflow-auto h-height-full flex-1 min-h-0"
            }`}
            style={{
              overflow: !isWheelScrolling && "hidden",
              marginBottom: !isWheelScrolling && "var(--margin-base)",
            }}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();

                return false;
              }
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center w-full h-full flex-1">
                <Loader />
              </div>
            ) : filteredData?.length > GlobalConfiguration.lengthCheckZero ? (
              <>
                <div
                  style={{
                    scrollPaddingTop: "var(--padding-md)",
                    scrollPaddingBottom: "var(--padding-md)",
                  }}
                  className={`scroll  flex flex-col min-h-0 items-center h-full-height overflow-y-auto ${showInnerSearchBar && "pointer-events-none"} w-full`}
                  ref={filterRef}
                >
                  <BeneficiaryAccountListView
                    id={id}
                    filterRef={filterRef}
                    associateTxn={associateTxn}
                    subType={subType}
                    type={type}
                    data={accumulatedData}
                    typepop={typepop}
                    handleButtonClick={handleButtonClick}
                    associateAccount={associateAccount}
                    beneAccountId={beneAccountId}
                    txnPayLoad={txnPayLoad}
                    setOpenBeneAssociate={setOpenBeneAssociate}
                    isLabelClicked={isLabelClicked}
                    handleLabelSelect={handleLabelAccountSelect}
                    LabelAccounts={LabelAccounts}
                    setlableInput={(e) => {}}
                    onCardNavigate={onCardNavigate}
                    setIsalertPopup={setIsalertPopup}
                    setFlowSelectedId={setFlowSelectedId}
                    classifiedFlow={classifiedFlow}
                  />
                </div>
              </>
            ) : accumulatedData?.length ===
                GlobalConfiguration?.lengthCheckZero &&
              filteredData?.length === GlobalConfiguration?.lengthCheckZero &&
              !loading ? (
              <div
                className="flex flex-col items-center justify-center m-auto w-full h-full"
                style={{
                  height:
                    (typepop === "popup" ||
                      type === "activeInactive" ||
                      type === "confirm_create_account") &&
                    showSearchBar
                      ? "var(--width-full)"
                      : "",
                  overflowY: showSearchBar && "scroll",
                }}
              >
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
                />
                <p
                  className={`text-font-sm text-text-primary items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  No data found.
                </p>

                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <></>
                    // <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                    //   {accActiveInactiveState === "active"
                    //     ? "There are no existing active accounts linked to the provided bank under the beneficiary account classification."
                    //     : "There are no existing inactive accounts linked to the provided bank under the beneficiary account classification."}
                    // </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <></>
                    // <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                    //   {accActiveInactiveState === "active"
                    //     ? "There are no existing active accounts linked to the provided PAN under the beneficiary account classification."
                    //     : "There are no existing inactive accounts linked to the provided PAN under the beneficiary account classification."}
                    // </p>
                  )
                ) : (
                  (type === "confirm_create_account"
                    ? currentCategory !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied ||
                      (activeType === "Pan"
                        ? accountNumber !== "" || isIfsc !== ""
                        : panNumber !== "")
                    : currentCategory !== "" ||
                      panNumber !== "" ||
                      accountNumber !== "" ||
                      isIfsc !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearSearchParam();
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center  Qsmd:absolute w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default BeneficiaryAccountViewAll;
